import { render, staticRenderFns } from "./PdfTable.vue?vue&type=template&id=2959901a&scoped=true"
import script from "./PdfTable.vue?vue&type=script&lang=js"
export * from "./PdfTable.vue?vue&type=script&lang=js"
import style0 from "./PdfTable.vue?vue&type=style&index=0&id=2959901a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2959901a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
